export default {
  shortUrl: '/tidy',
};
